/**
 * App Configuration
 * Centralized configuration for the BroviCMS admin panel
 */

// App config interface
interface AppConfig {
  name: string;
  version: string;
  environment: 'development' | 'staging' | 'production';
  maintenanceMode: boolean;
  features: {
    donations: boolean;
    sharing: boolean;
    social: boolean;
  };
  limits: {
    maxFileSize: number;
    maxUploads: number;
    maxLibraryItems: number;
    maxCollections: number;
  };
  integrations: Record<string, any>;
}

export const APP_NAME = 'Aatma ki Yatra CMS';
export const APP_VERSION = '1.0.0';
export const APP_ENVIRONMENT: 'development' | 'staging' | 'production' = 'development';
export const APP_MAINTENANCE_MODE = false;

export const APP_FEATURES = {
  donations: true,
  sharing: true,
  social: true,
} as const;

export const APP_LIMITS = {
  maxFileSize: 1024 * 1024 * 10, // 10MB
  maxUploads: 10,
  maxLibraryItems: 100,
  maxCollections: 10,
} as const;

export const APP_INTEGRATIONS: Record<string, any> = {
  // Add integration configurations here
};

export const APP_CONFIG: AppConfig = {
  name: APP_NAME,
  version: APP_VERSION,
  environment: APP_ENVIRONMENT,
  maintenanceMode: APP_MAINTENANCE_MODE,
  features: APP_FEATURES,
  limits: APP_LIMITS,
  integrations: APP_INTEGRATIONS,
};

export default APP_CONFIG;